import { useTranslation } from 'react-i18next'

import { Alert } from '@reveni-io/reveni-ui'

import WhiteLabelThemeProvider from '@/configuration/components/WhiteLabelThemeProvider/WhiteLabelThemeProvider'

import { buttonSubTabs, previewConfig } from '../constants'
import ButtonsPreviewContent from './ButtonsPreviewContent/ButtonsPreviewContent'
import { buildButtonsPreviewTheme } from './helpers'
import * as Styles from './styles'

const ButtonsPreview = ({ colors, activeSubTab = buttonSubTabs.primaryButtons }) => {
  const { t } = useTranslation()

  const config = previewConfig[activeSubTab]

  const buildPreviewTheme = whiteLabelTheme => buildButtonsPreviewTheme(colors, whiteLabelTheme, config)

  return (
    <Styles.Container>
      <Styles.PreviewContent>
        <WhiteLabelThemeProvider buildTheme={buildPreviewTheme}>
          <ButtonsPreviewContent config={config} />
        </WhiteLabelThemeProvider>
        <Styles.AlertWrapper>
          <Alert type="info">
            {t(config.alertLabel || 'Para ver el estilo hover coloca el cursor sobre el botón activo')}
          </Alert>
        </Styles.AlertWrapper>
      </Styles.PreviewContent>
    </Styles.Container>
  )
}

export default ButtonsPreview
